<template>
  <div id="EditEPaper2" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回信件列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
        <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>主旨:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].title"
                  ref="inputData[0].title"
                  placeholder="請輸入主旨"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>是否發送過
              <div class="input-group-text">
                <input
                  type="radio"
                  name="inputData[0].send"
                  value="false"
                  checked

                  v-model="inputData[0].send"
                  aria-label="Radio button for following text input"
                />否

                <input
                  type="radio"
                  name="inputData[0].send"
                  value="true"

                  v-model="inputData[0].send"
                  aria-label="Radio button for following text input"
                />有
              </div>
            </td>
          </tr>
    <tr align="left">
            <td>
              <span class="red_star">＊</span>內容：
              <ckeditor
                :config="config"
                placeholder="請輸入內容"
                v-model="inputData[0].content"
                ref="inputData[0].content"
              ></ckeditor>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="EditEPaper2()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>

  </div>
</template>

<script>
import * as tools from '../tool'
// import Ckeditor from "vue-ckeditor2";
import CkEditor from 'ckeditor4-vue'
import '../../static/config.js' // 使用相对路径引用 config.js 文件
export default {
  name: 'EditEPaper2',
  props: ['id'],
  components: {
    Ckeditor: CkEditor.component
  },
  data () {
    return {
      RowId: '',
      AttachContent: [],
      mode: false,
      file: [{ name: '', RowId: '' }],
      inputFlag: false,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: [{
        title: null,
        content: null,
        showAttached: true,
        Info: [],
        send: false

      }],
      currentPage: 1,
      eid: '',
      pageSize: 10,
      config: {
        versionCheck: false,
        toolbar: [
          ['Source', '-', 'Preview', '-', 'Templates'],
          [
            'Cut',
            'Copy',
            'Paste',
            'PasteText',
            'PasteFromWord',
            '-',
            'Undo',
            'Redo'
          ],
          ['Find', 'Replace', '-', 'SelectAll', '-', ''],
          [
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            '-',
            'CopyFormatting',
            'RemoveFormat'
          ],
          [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'Blockquote',
            'CreateDiv',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl',
            'Language'
          ],
          ['Link', 'Unlink', 'Anchor'],
          [
            'Image',
            'Table',
            'HorizontalRule',
            'Smiley',
            'SpecialChar',
            'PageBreak',
            'Iframe'
          ],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['TextColor', 'BGColor'],
          ['Maximize', 'ShowBlocks'],
          ['About']
        ],
        font_names: '標楷體/標楷體, Microsoft JhengHei, DFKai-SB, sans-serif;' +
        'Arial/Arial, Helvetica, sans-serif;' +
        'Comic Sans MS/Comic Sans MS, cursive;' +
        'Courier New/Courier New, Courier, monospace;' +
        'Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;' +
        'Tahoma/Tahoma, Geneva, sans-serif;' +
        'Times New Roman/Times New Roman, Times, serif;' +
        'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
        'Verdana/Verdana, Geneva, sans-serif;'
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }

  },
  methods: {

    hideModal (name) {
      this.$refs[name].hide()
    },

    checkInput () {
      this.inputFlag = false
      if (this.empty(this.inputData[0].title)) {
        alert('請輸入主旨')
        this.$refs['inputData[0].title'].focus()
        this.inputFlag = true
        return
      }

      if (this.empty(this.inputData[0].content)) {
        alert('請輸入內容')
        this.$refs['inputData[0].content'].focus()
        this.inputFlag = true
      }
    },
    empty (str) {
      if (
        typeof str === 'undefined' ||
        !str ||
        str.length === 0 ||
        str === '' ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true
      } else {
        return false
      }
    },
    EditEPaper2 () {
      this.checkInput()
      this.inputData[0].updateUser = this.user.id

      const vm = this

      if (this.inputFlag != true) {
        this.$http
          .put('./WebApi/EconomicDisadvantage/EditEPaper2/', this.inputData[0])
          .then((response) => {
            if (response.data > 0) {
              tools.showAlert(vm, 'success', '更新信件成功')
              this.close()
            } else {
              tools.showAlert(vm, 'danger', '對不起,更新信件失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },

    close () {
      this.$emit('hideModal')
    }

  },
  created () {
    console.log('======created EditEPaper2View =====')

    const vm = this

    vm.eid = this.$props.id
    this.$http
      .get('../WebApi/EconomicDisadvantage/GetEPaper2Detail/'.concat(this.eid))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data
        }
      })
      .catch(function (error) {
        alert('網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
